import React, { useState, Fragment } from 'react';
import { useQuery } from '@apollo/client';

import ProductsList from './ProductsList';
import EditRoutingRule from './EditRoutingRule';
import ShowHistoryButton from './ShowHistoryButton';
import RoutingRulesAuditLog from './RoutingRulesAuditLog';
import GET_PRODUCTS_ROUTING_RULE from '../queries/products-routing-rule.graphql';

const GroupRule = ({ groupId, allowEditRuleCode }) => {
  const [editedSpecialty, setEditedSpecialty] = useState();
  const [showHistory, setShowHistory] = useState(false);

  const { data, loading } = useQuery(GET_PRODUCTS_ROUTING_RULE, {
    variables: {
      groupId: String(groupId)
    }
  });

  const onCloseForm = () => {
    setEditedSpecialty();
  };

  const onEditSpecialty = specialtyData => {
    setEditedSpecialty(specialtyData);
    setShowHistory(false);
  };

  const onChangeHistoryState = () => setShowHistory(!showHistory);

  if (loading) return 'Loading...';

  return (
    <div className="assign-rule-to-group pb-8">
      <h2>Routing Rules</h2>
      {editedSpecialty ? (
        <EditRoutingRule specialty={editedSpecialty} groupId={groupId} onClose={onCloseForm} />
      ) : (
        <Fragment>
          <ProductsList
            allowEditRuleCode={allowEditRuleCode}
            data={data && data.routingRulesPerSpecialty}
            onEditSpecialty={onEditSpecialty}
          />
          <ShowHistoryButton show={showHistory} onClick={onChangeHistoryState} />
          {showHistory && <RoutingRulesAuditLog groupId={groupId} />}
        </Fragment>
      )}
    </div>
  );
};

export default GroupRule;
